import { createCrudApi } from "@/utils/apiFactory"
import { ID, PaginationResult } from "@/types/common"
import { SystemDict, SystemDictFormData } from "../types"

const baseApi = createCrudApi<SystemDict, SystemDictFormData, Partial<SystemDictFormData>>(
  "/system-dicts"
)

const systemDictApi = {
  async getList(): Promise<PaginationResult<SystemDict>> {
    return baseApi.list()
  },

  async getById(id: ID): Promise<SystemDict | null> {
    return baseApi.getById(id)
  },

  async create(data: SystemDictFormData): Promise<void> {
    await baseApi.create(data)
  },

  async update(id: ID, data: SystemDictFormData): Promise<void> {
    await baseApi.update(id, data)
  },

  async delete(ids: ID[]): Promise<void> {
    await baseApi.delete(ids)
  },
}

export default systemDictApi
